
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/knowledge/author/[id]/page/[pageNo]",
      function () {
        return require("private-next-pages/knowledge/author/[id]/page/[pageNo].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/knowledge/author/[id]/page/[pageNo]"])
      });
    }
  